export const uk = {
    '0-17': 'Младше 18',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': 'Старше 55',
    age: 'Возраст',
    'all-ages': 'Любой',
    'all-genders': 'Все',
    female: 'Ж',
    male: 'M'
};
